import axios from 'axios';
const OPEN_API_ROOT = `${process.env.NODE_ENV==='production' ? 'https://appapi.zlfund.cn/restful/' : 'https://officeapi.zlfund.cn/restful/'}`

function buildRequestData(args) {
    let {
        body={}, 
        auth,
    } = args || {};

    let data = {
        msg: {body}
    };

    if (auth) {
        data.msg.auth = auth;
    }

    return data;
}

export function calc (opts) {
    return axios({
        method: 'post',
        url: `${OPEN_API_ROOT}hormats/asset/calc/`,
        data: buildRequestData({body: opts}),
        timeout: 60000,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            "mctcode": "9999"
        }
    }).then(res => {
        return res.data.msg.body
    })
}

export function getNav (opts) {
    return axios({
        method: 'post',
        url: `${OPEN_API_ROOT}hormats/asset/nav/`,
        data: buildRequestData({body: opts}),
        timeout: 60000,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            "mctcode": "9999"
        }
    }).then(res => {
        return res.data.msg.body
    })
}

export function submitRes (opts) {
    return axios({
        method: 'post',
        url: `${OPEN_API_ROOT}hormats/asset/submitResult/`,
        data: buildRequestData({body: opts}),
        timeout: 60000,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            "mctcode": "9999"
        }
    }).then(res => {
        return res.data.msg.body
    })
}

export function getFullReport (opts) {
    return axios({
        method: 'post',
        url: `${OPEN_API_ROOT}hormats/asset/getFullReport/`,
        data: buildRequestData({body: opts}),
        timeout: 60000,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            "mctcode": "9999"
        }
    }).then(res => {
        return res.data.msg.body
    })
}